const reportType = {
  // get upload STATUS
  GET_REPORT_STATUS: "GET_REPORT_STATUS",
  GET_REPORT_STATUS_COMMIT: "GET_REPORT_STATUS_COMMIT",
  GET_REPORT_STATUS_ROLLBACK: "GET_REPORT_STATUS_ROLLBACK",
};

export default reportType;
